export default {
      id: "checkmark-usage",
      viewBox: "0 0 35 35",
      url: __webpack_public_path__ + "sprite-46b249.svg#checkmark-usage",
      toString: function () {
        return this.url;
      }
    }